import type { IconData } from '@stacksjs/iconify-core'

export const travelFlag: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 0H0v16h4v-4h12l-6-6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default travelFlag
